import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Panel from '@/components/Panel'
import ClearPanel from '@/components/ClearPanel'
import workbench from '@/page/workbench/index'
import parking from '@/page/parking/index'
// import monthlyCard from '@/page/monthlyCard/index'
import passCar from '@/page/passCar/index'
import white from '@/page/white/index'
import simple from '@/page/simple/index'
// import timePackage from '@/page/timePackage/index'
// import rate from '@/page/rate/index'
// import business from '@/page/business/index'
// import filed from '@/page/filed/index'
// import account from '@/page/account/index'
// import car from '@/page/car/index'
// import bill from '@/page/bill/index'
// import income from '@/page/income/index'
// import incomeReport from '@/page/incomeReport/index'
// import cashbook from '@/page/cashbook/index'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: Login
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login
        },
        {
          path: '/ClearPanel',
            component: ClearPanel,
            children: [
                {
                  path: '/simple',
                  name: 'simple',
                  component: simple
                }
            ]
        },
        {
            path: '/Panel',
            component: Panel,
            children: [
                {
                  path: '/workbench',
                  name: 'workbench',
                  component: workbench
                },
                {
                  path: '/white',
                  name: 'white',
                  component: white
                },
                {
                  path: '/passCar',
                  name: 'passCar',
                  component: passCar
                },
                // {
                //   path: '/parking',
                //   name: 'parking',
                //   component: parking
                // }, {
                //   path: '/monthlyCard',
                //   name: 'monthlyCard',
                //   component: monthlyCard
                // }, {
                //   path: '/timePackage',
                //   name: 'timePackage',
                //   component: timePackage
                // }, {
                //   path: '/rate',
                //   name: 'rate',
                //   component: rate
                // }, {
                //   path: '/business',
                //   name: 'business',
                //   component: business
                // }, {
                //   path: '/filed',
                //   name: 'filed',
                //   component: filed
                // },
                // {
                //   path: '/account',
                //   name: 'account',
                //   component: account
                // },
                // {
                //   path: '/car',
                //   name: 'car',
                //   component: car
                // },
                // {
                //   path: '/bill',
                //   name: 'bill',
                //   component: bill
                // },
                // {
                //   path: '/income',
                //   name: 'income',
                //   component: income
                // },
                // {
                //   path: '/incomeReport',
                //   name: 'incomeReport',
                //   component: incomeReport
                // },
                // {
                //   path: '/cashbook',
                //   name: 'cashbook',
                //   component: cashbook
                // },

            ]
        },
        {
            path: '*',
            name: 'index',
            component: Login
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js